import React from "react";
import { useNavigate } from "react-router-dom";
import "./floatingregisterbutton.css";

const FloatingRegisterButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/birthday-parties/");
  };

  return (
    <div className="floating-register-btn" onClick={handleClick} title="Register for Birthday Party">
      <i className="ri-calendar-check-fill text-clip"></i>
    </div>
  );
};

export default FloatingRegisterButton;
